"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroSection() {
  return <section id="hero-section" className="bg-background relative min-h-[90vh] flex items-center overflow-hidden py-20 lg:py-0">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-accent/20 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col justify-center space-y-8 max-w-2xl">
            <div className="space-y-6">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[72px] font-bold font-default text-chart-5 leading-[1.1] tracking-tight">Practical Stress Risk Diagnostic for Organisations</h1>
              <p className="text-sm sm:text-base md:text-[17px] font-default text-foreground/90 leading-relaxed max-w-xl">
                Decision-ready insight to measure, manage, and mitigate workplace stress effectively. Empower your leadership with multi-dimensional, actionable assessments.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button asChild size="lg" className="bg-primary text-background hover:bg-primary/90 rounded-lg hover:scale-[1.02] transition-all duration-200 text-base h-14 px-8 shadow-lg shadow-primary/20 group">
                <Link href="https://outlook.office.com/bookwithme/user/7ee7c38a7b494deb9a20733b22aedc2b@feelgood.works/meetingtype/wwueEkaxA0arcv5Tg9S6uA2?anonymous&ismsaljsauthenabled&ep=mLinkFromTile" newTab>
                  Book a Demo
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-lg border-2 border-foreground text-foreground hover:bg-foreground/5 text-base h-14 px-8 transition-colors duration-200">
                
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full aspect-square max-w-[600px] mx-auto lg:ml-auto flex items-center justify-center mt-10 lg:mt-0">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-chart-2/15 rounded-lg blur-3xl mix-blend-multiply dark:mix-blend-screen pointer-events-none" />
            <div className="absolute top-1/3 left-1/3 w-[60%] h-[60%] bg-chart-3/15 rounded-lg blur-3xl mix-blend-multiply dark:mix-blend-screen pointer-events-none" />

            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645819/img/Risk Radar Logo.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645819/img/Risk Radar Logo.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645819/img/Risk Radar Logo.png-wvc-sizes" alt="Wellbeing Risk Radar Diagnostic" className="relative z-10 w-full max-w-[500px] h-auto object-contain drop-shadow-2xl" loading="lazy" decoding="async" />
          </div>

        </div>
      </div>
    </section>;
}